import { render, staticRenderFns } from "./FramedImage.vue?vue&type=template&id=1d1b7cdc&scoped=true&"
import script from "./FramedImage.vue?vue&type=script&lang=js&"
export * from "./FramedImage.vue?vue&type=script&lang=js&"
import style0 from "./FramedImage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FramedImage.vue?vue&type=style&index=1&id=1d1b7cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1b7cdc",
  null
  
)

export default component.exports